import React, {Component} from 'react';
import VirtualizedTable from "../common/virtualized-table";
import {connect} from 'react-redux';
import {Radio} from "@blueprintjs/core";
import {List} from "immutable";

// Actions
import {getProducts, cleanProducts} from "../../actions/products";
import {createStock} from "../../actions/stock";

class RegisterStockDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filterProduct_code: '',
            filterName: '',
            warehouse: this.props.warehouseId,
            product: '',
            real_amount: '',
            security_stock: '0'
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.onCreateClick !== prevProps.onCreateClick && this.props.onCreateClick) {
            this.props.createStock({
                warehouse: this.state.warehouse,
                product: this.state.product,
                real_amount: this.state.real_amount,
                security_stock: this.state.security_stock
            }, {
                projection: 'product real_amount available_amount total_amount security_stock',
                populateRefs: [{
                    field: 'product',
                    projection: 'name'
                }]
            });
            this.props.onCloseModal();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props !== nextProps ||
            this.state.product !== nextState.product
        );
    }

    componentWillUnmount() {
        this.props.cleanProducts();
    }

    validateStock = () => {
        if (
            this.state.warehouse &&
            this.state.product !== '' &&
            this.state.real_amount !== '' &&
            this.state.security_stock !== ''
        ) {
            this.props.onCanSubmit(true);
        } else {
            this.props.onCanSubmit(false);
        }
    };

    getProducts = () => {
        this.props.getProducts({
            regexFilters: {
                'product_code': this.state.filterProduct_code || '',
                'name': this.state.filterName || ''
            },
            projection: 'product_code name category_labels'
        });
    };

    render() {
        const { filterProduct_code, filterName, product, real_amount, security_stock } = this.state;
        const { products, warehouseName } = this.props;

        // Stock Table
        let tableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: 120,
            rowHeight: 40,
            strippedRows: false,
            conditionalRowStyle: [{
                dataField: '_id',
                operation: '=',
                value: product,
                style: {
                    backgroundColor: '#E8F1F7'
                }
            }],
            rowStyle: {
                color: '#676a6c'
            }
        };
        let tableData = products;
        let tableColumns = {
            product_code: {
                title: 'Código',
                columnType: 'text',
                dataField: 'product_code',
                width: 100,
                style: {},
                sortable: true,
                filterable: true
            },
            name: {
                title: "Nombre",
                columnType: 'text',
                dataField: 'name',
                width: 100,
                style: {},
                sortable: true,
                filterable: true
            },
            category_labels: {
                title: "Categorias",
                columnType: 'function',
                dataField: 'category_labels',
                width: 100,
                style: {},
                sortable: false,
                filterable: true,
                nodeContent: (category_labels) => {
                    category_labels = category_labels && category_labels.map( (category, i) => {
                        return i < category_labels.length -1 ? category + ', ' : category;
                    });

                    return category_labels;
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 100,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (productId) => {
                    return (
                        <Radio
                            style={{ marginTop: 10 }}
                            checked={ productId === product }
                            onChange={ () => this.setState({ product: productId }, this.validateStock) }
                        />
                    );
                }
            }
        };

        return (
            <div>
                <h4 style={{ color: 'black' }} >Almacén</h4>
                <div className="row modal-row">
                    <div className="col">
                        <span style={{ fontSize: '0.9rem' }} >{warehouseName}</span>
                    </div>
                </div>
                <h4 style={{ color: 'black' }} >Producto</h4>
                <div className="row modal-row">
                    <div className="col-3">
                        <label>Código</label>
                        <input
                            className="form-control"
                            type="text"
                            defaultValue={filterProduct_code}
                            onChange={ (event) => this.setState({ filterProduct_code: event.target.value }) }
                        />
                    </div>
                    <div className="col-3">
                        <label>Nombre</label>
                        <input
                            className="form-control"
                            type="text"
                            defaultValue={filterName}
                            onChange={ (event) => this.setState({ filterName: event.target.value }) }
                        />
                    </div>
                    <div className="col" style={{ paddingTop: 25 }}>
                        <button
                            className="btn btn-custom"
                            style={{ marginRight: 5 }}
                            onClick={ this.getProducts } >
                            Buscar
                        </button>
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <VirtualizedTable
                            tableSettings={tableSettings}
                            tableColumns={tableColumns}
                            tableData={tableData}
                        />
                    </div>
                </div>
                <h4 style={{ color: 'black' }} >Stock real</h4>
                <div className="row modal-row">
                    <div className="col-3">
                        <input
                            className="form-control"
                            type="text"
                            defaultValue={real_amount}
                            onChange={ (event) => this.setState({ real_amount: event.target.value }, this.validateStock) }
                        />
                    </div>
                </div>
                <h4 style={{ color: 'black' }} >Stock de seguridad</h4>
                <div className="row modal-row">
                    <div className="col-3">
                        <input
                            className="form-control"
                            type="text"
                            defaultValue={security_stock}
                            onChange={ (event) => this.setState({ security_stock: event.target.value }, this.validateStock) }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const productsReducer = state.products;

    // Products
    const products = productsReducer.get('payload') || List([]);

    return {
        products
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createStock: (stock, options) => dispatch(createStock(stock, options)),
        getProducts: (query) => dispatch(getProducts(query)),
        cleanProducts: () => dispatch(cleanProducts())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterStockDialog);


// WEBPACK FOOTER //
// ./src/components/dialogs/RegisterStockDialog.js